import { Link } from 'react-router-dom'
import { HiOutlineArrowRight } from 'react-icons/hi'
import { userService } from '../services/user.service'
import Logo from './logo'


export function HomeHeader({ boards }) {
    const loggedinUser = userService.getLoggedinUser()
    return (
        <header className="home-header">
            <Logo />
            <div className='header-btns'>
                {loggedinUser ? (
                    <></>
                    // <Link to={'/'}><button className='btn-start'>My Boards <span className="arrow"><HiOutlineArrowRight /></span></button></Link>
                ) : (
                    <>
                        <Link to={'/auth/login'}><button className="btn-login">Log in</button></Link>
                        <Link to={'/auth/login'}><button className='btn-start'>Get started <span className="arrow"><HiOutlineArrowRight /></span></button></Link>
                    </>
                )}
            </div>
        </header>
    )
}